import { Injectable } from '@angular/core';
import { AutocompleteGroupSuggestions } from '@cpak/interfaces';

@Injectable({ providedIn: 'root' })
export class SearchHistoryService {
  private _updatedSearchHistory: AutocompleteGroupSuggestions = [];

  public updateFullSearchHistory(history: AutocompleteGroupSuggestions): void {
    this._updatedSearchHistory = history;
  }

  public getUpdatedSearchHistory(): AutocompleteGroupSuggestions {
    return this._updatedSearchHistory;
  }

  public addLastSearchValue(value: string): void {
    const historyResultsQuery = this.createUniqueQuery(this._updatedSearchHistory[0].items, value);
    this._updatedSearchHistory[0].items = historyResultsQuery.slice(0, 10);
  }

  private createUniqueQuery(queryToUpdate: string[], valueToAdd: string): string[] {
    const query = [...queryToUpdate];
    const indexOfItemToDelete = query.findIndex(item => item === valueToAdd);

    if (indexOfItemToDelete === -1) {
      query.unshift(valueToAdd);
      return query;
    } else {
      query.splice(indexOfItemToDelete, 1);
      return this.createUniqueQuery(query, valueToAdd);
    }
  }
}
